/**
 * parse string template to phrases
 * @example
 *  str = `<%= time %>, <%= columnAlias$$metric_name$$ %> is <%= price$$metric_value$$ %>`
 *  data = { time: "2020", columnAlias: "price total", price: "123" }
 *  =>
 *  [
 *    { type: "text", value: "2020" },
 *    { type: "text", value: ", " },
 *    { type: "entity", value: "price total", metadata: { entityType: metric_name } },
 *    { type: "text", value: " is " },
 *    { type: "entity", value: "123", metadata: { entityType: metric_value } },
 *  ]
 */
export function generateSentence(template, formattedData, originalData) {
    const splitReg = /(<%= [\s\S]*?(::\w*?)? %>)/;
    const variableReg = /<%= ([\s\S]*?)(\$\$(\w*)\$\$)? %>/;
    return template.split(splitReg).reduce((prev, curr) => {
        if (curr) {
            const variable = variableReg.exec(curr);
            if (variable && variable[1] && formattedData && typeof formattedData[variable[1]] === 'string') {
                const formattedVal = formattedData[variable[1]];
                if (variable[3]) {
                    const eType = variable[3];
                    const result = {
                        type: 'entity',
                        value: formattedVal,
                        metadata: {
                            entityType: eType,
                        },
                    };
                    const origin = originalData ? originalData[variable[1]] : undefined;
                    if ((result.metadata.entityType === 'delta_value' || result.metadata.entityType === 'ratio_value') &&
                        typeof origin === 'number') {
                        if (origin > 0) {
                            result.metadata.assessment = 'positive';
                        }
                        if (origin < 0) {
                            result.metadata.assessment = 'negative';
                        }
                    }
                    prev.push(result);
                }
                else {
                    prev.push({
                        type: 'text',
                        value: formattedVal,
                    });
                }
            }
            else {
                prev.push({
                    type: 'text',
                    value: curr,
                });
            }
        }
        return prev;
    }, []);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVtcGxhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdG9vbHMvdGVtcGxhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7Ozs7Ozs7Ozs7Ozs7R0FhRztBQUNILE1BQU0sVUFBVSxnQkFBZ0IsQ0FDOUIsUUFBZ0IsRUFDaEIsYUFBc0MsRUFDdEMsWUFBc0M7SUFFdEMsTUFBTSxRQUFRLEdBQUcsNEJBQTRCLENBQUM7SUFDOUMsTUFBTSxXQUFXLEdBQUcsbUNBQW1DLENBQUM7SUFDeEQsT0FBTyxRQUFRLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDLE1BQU0sQ0FBZSxDQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsRUFBRTtRQUNsRSxJQUFJLElBQUksRUFBRTtZQUNSLE1BQU0sUUFBUSxHQUFHLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDeEMsSUFBSSxRQUFRLElBQUksUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLGFBQWEsSUFBSSxPQUFPLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxRQUFRLEVBQUU7Z0JBQzlGLE1BQU0sWUFBWSxHQUFHLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDaEQsSUFBSSxRQUFRLENBQUMsQ0FBQyxDQUFDLEVBQUU7b0JBQ2YsTUFBTSxLQUFLLEdBQUcsUUFBUSxDQUFDLENBQUMsQ0FBZSxDQUFDO29CQUN4QyxNQUFNLE1BQU0sR0FBZTt3QkFDekIsSUFBSSxFQUFFLFFBQVE7d0JBQ2QsS0FBSyxFQUFFLFlBQVk7d0JBQ25CLFFBQVEsRUFBRTs0QkFDUixVQUFVLEVBQUUsS0FBSzt5QkFDbEI7cUJBQ0YsQ0FBQztvQkFFRixNQUFNLE1BQU0sR0FBRyxZQUFZLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDO29CQUNwRSxJQUNFLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxVQUFVLEtBQUssYUFBYSxJQUFJLE1BQU0sQ0FBQyxRQUFRLENBQUMsVUFBVSxLQUFLLGFBQWEsQ0FBQzt3QkFDOUYsT0FBTyxNQUFNLEtBQUssUUFBUSxFQUMxQjt3QkFDQSxJQUFJLE1BQU0sR0FBRyxDQUFDLEVBQUU7NEJBQ2QsTUFBTSxDQUFDLFFBQVEsQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO3lCQUN6Qzt3QkFDRCxJQUFJLE1BQU0sR0FBRyxDQUFDLEVBQUU7NEJBQ2QsTUFBTSxDQUFDLFFBQVEsQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO3lCQUN6QztxQkFDRjtvQkFFRCxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO2lCQUNuQjtxQkFBTTtvQkFDTCxJQUFJLENBQUMsSUFBSSxDQUFDO3dCQUNSLElBQUksRUFBRSxNQUFNO3dCQUNaLEtBQUssRUFBRSxZQUFZO3FCQUNwQixDQUFDLENBQUM7aUJBQ0o7YUFDRjtpQkFBTTtnQkFDTCxJQUFJLENBQUMsSUFBSSxDQUFDO29CQUNSLElBQUksRUFBRSxNQUFNO29CQUNaLEtBQUssRUFBRSxJQUFJO2lCQUNaLENBQUMsQ0FBQzthQUNKO1NBQ0Y7UUFDRCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztBQUNULENBQUMifQ==